import { createFileRoute } from "@tanstack/react-router";
import { FestivalPage, buildHomeHead } from "@/components/festival/Page";

export const Route = createFileRoute("/de")({
  head: () => buildHomeHead("de"),
  component: () => <FestivalPage lang="de" />,
});